import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ParseDataToValue {
	parse(data: any, field: string): void {
		if (field) {
			if (field.indexOf('.') > 0) {
				const fields = field.split('.');
				return this.parse(data[fields[0]], fields[1]);
			}
		}
		return data !== undefined ? data[field] : undefined;
	}
}
